import React from 'react';
import PropTypes from 'prop-types';
import TranslationContainer from '../../../translation/translation_container';
import { LightboxView } from './view_sections/lightbox_view';
import { LightboxViewHeadline } from './view_sections/lightbox_view_headline';
import { LightboxViewContent } from './view_sections/lightbox_view_content';
import { LightboxViewAction } from './view_sections/view_actions/lightbox_view_action';
import { LightboxFilterSelect } from './filters/lightbox_filter_select';
import { FilterSections } from '../../../../constants/filter/filter_sections';
import { Filters } from '../../../../constants/filter/filters';
import { FilterSectionLabelTranslationKeys } from '../../../../constants/filter/filter_section_label_translation_keys';
import { FilterLabelTranslationKeys } from '../../../../constants/filter/filter_label_translation_keys';
import { addLoadIndexAbsoluteValueToLabel } from '../../../../../_modules/tyre_index/add_load_index_absolute_value_to_label';
import getTranslatedText from '../../../../helper/get_translated_text';
import { getSpeedIndexAbsoluteValue } from '../../../../../_modules/tyre_index/get_speed_index_for_absolute_value';
import { map } from '../../../../../../lib/utilities';


function LightboxTyreIndex(props) {
    const sectionHeadlineTranslationKey = FilterSectionLabelTranslationKeys[FilterSections.TYRE_INDEX_VIEW];
    const loadIndexTranslationKey = FilterLabelTranslationKeys[Filters.LOAD_INDEX];
    const speedIndexTranslationKey = FilterLabelTranslationKeys[Filters.SPEED_INDEX];

    const rawLoadIndexOptions = map(props.loadIndexOptions, option => [ option[0], addLoadIndexAbsoluteValueToLabel(option[0]) ]);
    const rawSpeedIndexOptions = map(props.speedIndexOptions, option => {
        const speedIndex = getSpeedIndexAbsoluteValue(option[0]);
        return [
            option[0],
            getTranslatedText('speed-index-absolute-value-hint', {
                SPEED_INDEX: speedIndex,
                ABSOLUTE_VALUE: option[0]
            }),
        ];
    });

    return (
        <LightboxView
            viewName={FilterSections.TYRE_INDEX_VIEW}
            opened={props.opened}
        >
            <TranslationContainer translationKey={sectionHeadlineTranslationKey} targetProperty="headline">
                <LightboxViewHeadline headline="will-be-replaced" />
            </TranslationContainer>

            <LightboxViewContent>
                <LightboxFilterSelect
                    name={Filters.LOAD_INDEX}
                    value={props.loadIndexValue}
                    options={rawLoadIndexOptions}
                    labelTranslationKey={loadIndexTranslationKey}
                    provideAllTranslationKey={loadIndexTranslationKey}
                    onChange={props.onChange}
                    provideAllOption={true}
                    highlight={!props.loadIndexValue}
                />

                <LightboxFilterSelect
                    name={Filters.SPEED_INDEX}
                    value={props.speedIndexValue}
                    options={rawSpeedIndexOptions}
                    labelTranslationKey={speedIndexTranslationKey}
                    provideAllTranslationKey={speedIndexTranslationKey}
                    onChange={props.onChange}
                    provideAllOption={true}
                    highlight={!!props.loadIndexValue && !props.speedIndexValue}
                />
            </LightboxViewContent>

            <LightboxViewAction
                onCloseClick={props.resetSection}
                onSaveClick={props.saveSection}
            />
        </LightboxView>
    );
}

LightboxTyreIndex.propTypes = {
    loadIndexValue: PropTypes.number.isRequired,
    speedIndexValue: PropTypes.number.isRequired,
    loadIndexOptions: PropTypes.array.isRequired,
    speedIndexOptions: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
    resetSection: PropTypes.func.isRequired,
    saveSection: PropTypes.func.isRequired,
    opened: PropTypes.bool.isRequired,
};

export { LightboxTyreIndex };
